import * as React from "react";

export default class Tab<T> {
    path: string;
    element: React.FC<T>;
    isDefault: boolean = false;
    label: string;
    showInSidebar: boolean = false;
    sidebarLabel: string = "";
    sidebarIcon: React.ReactNode;

    constructor(path: string, element: React.FC<T>, isDefault: boolean, label: string) {
        this.path = path;
        this.element = element;
        this.isDefault = isDefault;
        this.label = label;
    }

    setSidebar(label: string, icon: React.ReactNode) {
        this.sidebarLabel = label;
        this.sidebarIcon = icon;
        this.showInSidebar = true;
    }

    getPage() {
        const page: any =  {
            type: this.isDefault ? "index" : "path",
            element: this.element,
            public: true,
        }
        if (this.showInSidebar) {
            page.sidebar = {
                label: this.sidebarLabel,
                icon: this.sidebarIcon
            }
        }
        return page;
    }
}